import { RuleObject } from "antd/es/form"
import { PermissionString } from "@/types/user"

export enum MediaType {
  IMAGE = 1,
  VIDEO = 2,
}

type MediaSource = {
  id: number
  file_name: string
  file_path: string
  media_type: string
  mime_type: string
  file_size: number
  file_type: MediaType
  thumbnail_url?: string
  duration_seconds?: number | null
  display_order?: number
  video_length?: number
}

type RouteTreeNode = {
  path: string
  breadcrumbName?: string
  label?: string
  icon?: React.ReactNode
  children?: RouteTreeNode[]
  isShowBreadcrumbHeader?: boolean
  accessibleRoles?: string[]
  permission?: PermissionString
}

type Rule = RuleObject & {
  message: string
}

type FormattedValidationError = {
  name: (string | number)[]
  errors: string[]
}

export type { MediaSource, FormattedValidationError, RouteTreeNode, Rule }
